import { useMemo } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PRODUCTS, CATEGORIES } from "@/data/catalog";
import { ProductCard } from "@/components/ProductCard";

export default function Search() {
  const { t } = useTranslation();
  const [sp] = useSearchParams();
  const q = (sp.get("q") || "").trim().toLowerCase();
  const list = useMemo(() => (q ? PRODUCTS.filter((p) => `${p.name} ${p.brand} ${p.code} ${t(`subs.${p.sub}`)}`.toLowerCase().includes(q)) : []), [q, t]);
  return (
    <main className="nv-container py-12">
      <p className="nv-eyebrow">{list.length ? t("search.title") : t("search.none")}</p>
      <h1 data-testid="search-title" className="mt-2 font-display text-4xl font-bold sm:text-5xl">“{sp.get("q")}”</h1>
      {list.length === 0 ? (
        <div data-testid="search-empty" className="mt-12 rounded-3xl bg-[#f4f5f0] p-16 text-center">
          <p className="text-black/60">{t("search.hint")}</p>
          <div className="mt-6 flex flex-wrap justify-center gap-2">{CATEGORIES.map((c) => <Link key={c.id} to={`/c/${c.id}`} className="nv-btn-dark !px-5 !py-2.5 text-xs">{t(`nav.${c.id}`)}</Link>)}</div>
        </div>
      ) : (
        <div data-testid="search-grid" className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">{list.map((p, i) => <ProductCard key={p.code} p={p} index={i} />)}</div>
      )}
    </main>
  );
}
